import { Carousel } from '@fiverr-private/orca';

export const DEFAULT_CAROUSEL_BREAKPOINTS = {
    [Carousel.BREAKPOINTS.BP_600]: 1,
    [Carousel.BREAKPOINTS.BP_750]: 2,
    [Carousel.BREAKPOINTS.BP_900]: 2,
    [Carousel.BREAKPOINTS.BP_1000]: 3,
    [Carousel.BREAKPOINTS.BP_1160]: 3,
    [Carousel.BREAKPOINTS.BP_1300]: 4,
};

export const createDynamicSliderBreakpoints = (numOfSlides) => {
    const { BREAKPOINTS } = Carousel;
    const breakpointsArr = Object.values(BREAKPOINTS);

    return breakpointsArr.reduce((acc, breakpoint) => {
        const numOfSlidesForStaticBreakpoint = DEFAULT_CAROUSEL_BREAKPOINTS[breakpoint];
        const dynamicBreakpoint =
            numOfSlides < numOfSlidesForStaticBreakpoint ? numOfSlides : numOfSlidesForStaticBreakpoint;

        acc[breakpoint] = dynamicBreakpoint;

        return acc;
    }, {});
};
